import { aplicacion, aplicacionItem, AsignaturaItem, asignaturas, grado } from "../interface/data-core";

// Labels para los filtros
export const FILTER_LABEL_GRADO: string = 'grado';
export const FILTER_LABEL_CLASS_ASIGNATURA: string = 'class_asignatura';
export const FILTER_LABEL_ASIGNATURA: string = 'asignatura';
export const FILTER_LABEL_APLICACION: string = 'aplicacion';
export const FILTER_LABEL_TEMA: string = 'tema';
export const FILTER_LABEL_TEXTO: string = 'texto';
export const FILTER_LABEL_CATEGORIA: string = 'categoria';

export const CAT_LABEL_APLICACION: string = 'Aplicación';
export const CAT_LABEL_LECTURA: string = 'Lectura';
export const CAT_LABEL_VIDEO: string = 'Video';
export const CAT_LABEL_EVALUACION: string = 'Evaluación';
export const CAT_LABEL_SIMULACION: string = 'Simulador';

export const ASIGNATURA_COMPONENT_ID: string = 'asignaturas_component';
export const GRADOS_COMPONENT_ID: string = 'grados_component';
export const LISTADO_DINAMICO_ID: string = 'listado_dinamico';
export const LO_MAS_RECIENTE_ID: string = 'lo_mas_reciente';
//envia la pagina a donde se quiere
export function limitScroll(getControl: number): void {
    window.scroll({
        top: getControl,
        behavior: "smooth",
    });
}


/**
 *
 * @param idComponent id html del componente a enviar al usuario
 */
export function onScrollComponente(idComponent: string) {
    const offsetElement = document.getElementById(idComponent);//Obtiene el elemento
        if (offsetElement) {
            const offsetBottom = Number(offsetElement?.offsetTop);//Obtiene el top del footer
            window.scroll({ top: offsetBottom - 125, left: 0, behavior: 'smooth' });
        }
}

export async function onAddClass(idComponent: string, nameClass: string): Promise<void> {
    const element = document.getElementById(idComponent);
    if (element) {
        element.classList.add(nameClass);
    }
}

export async function onRemoveClass(idComponent: string, nameClass: string): Promise<void> {
    const element = document.getElementById(idComponent);
    if (element) {
        element.classList.remove(nameClass);
    }
}



export function toggleClass(idComponent: string, nameClass: string) {
    const element = document.getElementById(idComponent);
    if (!element) return;
    element.classList.toggle(nameClass);
}

/**
 * Muestra el elemento de búsqueda en la página agregando la clase 'd_showall'
 * al elemento con el id 'd_overlaycontegrl_searchhome', si existe.
 */
export function openSearch() {
    const getSearchinelement = document.querySelector("#d_overlaycontegrl_searchhome");//Obtiene el elemento principal
    if (getSearchinelement) {
        getSearchinelement.classList.add('d_showall');
    }
}


/**
 * Cierra la búsqueda ocultando el elemento principal de búsqueda en la página.
 * Elimina la clase 'd_showall' del elemento con el id 'd_overlaycontegrl_searchhome' si existe.
 */
export function closeSearch() {
    const getSearchinelement = document.querySelector("#d_overlaycontegrl_searchhome");//Obtiene el elemento principal
    if (getSearchinelement) {
        getSearchinelement.classList.remove('d_showall');
    }
}




// 💡 Agrupar y mapear
export function agruparAsignaturas(lista: asignaturas[]): AsignaturaItem[] {
    const mapa = new Map<string, {
        listID: Set<number>;
        listGrados: Set<number>;
        clase: string;
    }>();

    for (const item of lista) {
        if (!mapa.has(item.n)) {
            mapa.set(item.n, {
                listID: new Set(),
                listGrados: new Set(),
                clase: item.class
            });
        }

        const grupo = mapa.get(item.n)!;
        grupo.listID.add(item.i);
        grupo.listGrados.add(item.g);
    }

    const resultado: AsignaturaItem[] = [];

    for (const [nombre, grupo] of mapa.entries()) {
        resultado.push({
            label: nombre,
            icon: null,  // Aquí puedes personalizar el ícono
            clase: grupo.clase,
            listID: Array.from(grupo.listID),
            listGrados: Array.from(grupo.listGrados)
        });
    }

    return resultado;
}


export function agruparAplicacionesPorGradoYAsignatura(aplicaciones: aplicacion[], grados: grado[], asignaturas: asignaturas[]): aplicacionItem[] {
    const mapa = new Map<string, aplicacionItem>();

    for (const app of aplicaciones) {
        const clave = `${app.g}-${app.a}`;
        if (!mapa.has(clave)) {
            mapa.set(clave, {
                g: app.g ?? 0,
                a: app.a ?? 0,
                listId: [app.i],
                grado: grados.find(g => g.i === app.g), // Objeto Grado relacionado
                asignatura: asignaturas.find(a => a.i === app.a), // Objeto Asignatura relacionado,
                action: () => { }
            });
        } else {
            mapa.get(clave)!.listId.push(app.i);
        }
    }

    return Array.from(mapa.values());
}

export function getAsignaturaById(id: number, dataAsignaturas: asignaturas[]): asignaturas | undefined {
    return dataAsignaturas.find(asignatura => asignatura.i === id);
}

export function getGradoById(id: number, dataGrados: grado[]): grado | undefined {
    return dataGrados.find(grado => grado.i === id);
}


export function openUrl(url: string): void {
    const miRedirect = document.createElement('a');
    miRedirect.setAttribute('href', url);
    miRedirect.setAttribute('target', '_blank');
    miRedirect.click();
}

/**
  * @description: Función para hacer scroll al final de la página
  */
export function scrollEnd(): void {
    window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
    });
}
